<div class="postback-url-container">
  <div *ngIf="!isSuccessfullySubmitted && !isGlobalConfiguration" class="postback-info-container">
    <h3>{{ 'view_translations.postback_url_info' | translate }} <a [routerLink]="'/postback-and-api'" (click)="closeModal()">Postback API</a></h3>
  </div>
  <div *ngIf="isSuccessfullySubmitted" class="postback-created-info-container">
    <h2>
      {{ ('view_translations.postback_url' | translate) + ' "' + address + '" ' + ('view_translations.' + (configurationData?.postback_id ? 'has_been_edited' :
      'postback_has_been_added') | translate) }}
    </h2>
    <h3 *ngIf="!isGlobalConfiguration">
      {{ 'view_translations.postback_url_info' | translate }} <a [routerLink]="'/postback-and-api'" (click)="closeModal()">Postback API</a>
    </h3>
  </div>
  <div class="bordered-container">
    <app-select-container
      [data]="selectData.data"
      [title]="selectData.title"
      [submitted]="submitted"
      [shouldTranslate]="true"
      (emitValue)="getSelectedValue($event)"
      [idOfDefaultValue]="idOfDefaultValue"
      [borderWidth]="2"
      [borderRadius]="10">
    </app-select-container>
  </div>
  <div class="postback-status-info-link">
    <h4
      class="tooltip-button tool-tip"
      container="body"
      [ngbTooltip]="'postback_api_lead_status' | t"
      placement="bottom"
      tooltipClass="my-configurations-tooltip wider-toolip">
      {{ 'view_translations.postback_status_info_link' | translate }}
    </h4>
  </div>
  <div class="bordered-container" *ngIf="!isGlobalConfiguration  && configurationData?.configuration_id?.values">
    <app-select-container
      [data]="configurationsSelectData.data"
      [title]="configurationsSelectData.title"
      [submitted]="submitted"
      [shouldTranslate]="false"
      [idOfDefaultValue]="idOfDefaultConfig"
      (emitValue)="getSelectedConfigurationValue($event)"
      [borderWidth]="2"
      [borderRadius]="10">
    </app-select-container>
  </div>
  <div class="postback-url">
    <app-postback-url
      #urlAddress
      [editData]="configurationData?.postback_url"
      [idOfRemovedParam]="idOfRemovedParam"
      [parameterAdded]="parameterAdded"
      [removedParam]="removedParam"
      [submitted]="submitted"
      [usedParameters]="usedParameters"
      (isUrlValid)="handleUrlValidity($event)">
    </app-postback-url>
  </div>
  <div *ngIf="!isSuccessfullySubmitted" class="postback-url-parameters">
    <app-postback-url-parameters
      (parameter)="getParameters($event)"
      [urlAddress]="urlAddress.urlAddressForm.value.urlAddress"
      [usedParameters]="usedParameters"
      [isUrlValid]="isUrlValid">
    </app-postback-url-parameters>
  </div>
</div>

<div class="btn-container" id="backToListButton">
  <app-primary-button (emitAction)="actionButton()" [background]="'orange'" [buttonText]="buttonText" [iconSize]="18" [icon]="'link'"> </app-primary-button>
</div>
